import { noop } from "lodash-es";

import { asyncNoop } from "@/utils/async/utils";
import { objectId } from "@/utils/objectId";

import type { BackendWriteSession } from "./BackendWriteSession";

const asyncAny = <T>() => Promise.resolve({} as T);

export function backendWriteSessionDummy(): BackendWriteSession {
  return {
    syncBacklog: asyncAny,
    syncIteration: asyncAny,
    sessionPublish: noop,
    boardPublish: noop,
    boardCall: asyncAny,
    addBoard: () => Promise.resolve(""),
    updateBoard: asyncNoop,
    deleteBoard: asyncNoop,
    duplicateFlex: asyncNoop,
    newSticky: () => Promise.resolve(""),
    mirror: asyncAny,
    move: noop,
    toRisk: noop,
    addLink: asyncAny,
    addObjectiveLink: asyncNoop,
    deleteLink: asyncNoop,
    deleteObjectiveLink: asyncNoop,
    addObjectiveObjectiveLink: asyncNoop,
    deleteObjectiveObjectiveLink: asyncNoop,
    addCategory: () => Promise.resolve(""),
    deleteCategory: asyncNoop,
    updateCategory: asyncNoop,
    addBoardToCategory: asyncNoop,
    removeBoardFromCategory: asyncNoop,
    createTimerEvent: () => Promise.resolve(""),
    updateTimerEvent: asyncNoop,
    deleteEvent: asyncNoop,
    addReaction: asyncNoop,
    removeReaction: asyncNoop,
    addShape: () => Promise.resolve(objectId()),
    editShape: asyncNoop,
    removeShape: asyncNoop,
    createConfidenceVoteSession: asyncAny,
    getConfidenceVoteSessions: asyncAny,
    endConfidenceVoteSession: asyncAny,
    joinConfidenceVoteSession: asyncAny,
    getConfidenceVoteSessionParticipants: asyncAny,
    getMyVote: asyncAny,
    addVote: asyncAny,
    deleteConfidenceVoteSession: asyncNoop,
    updateConfidenceVoteSession: asyncAny,
    startConfidenceVoteSession: asyncAny,
    deleteCard: asyncAny,
    getAlmKanbanConfigs: asyncAny,
    getAlmIssues: asyncAny,
    scaleBoard: noop,
    stickyToFront: noop,
    addObjective: noop,
    deleteObjective: noop,
    updateObjective: noop,
    moveObjective: noop,
    stickyUpdateStarted: noop,
    stickyUpdated: noop,
    stickyUpdateEnded: noop,
  };
}
